import toast from "react-hot-toast";

export const addFeedbackApi = async (platform, feedback) => {
  toast.success("your feedback has been submitted successfully!");
};
